import Vue from 'vue'
import Vuex from 'vuex'
import menuStore from './menu/menu-store'
import loginStore from './login/login-store'
import dialogs from './common/dialogs/dialogs-store'
import navigation from './navigation/navigation-store'
import menuPublish from '@/common/elements/config-publish/menus-publish-store'
import locations from './locations/locations-store'

Vue.use(Vuex)

// const sidebarCollapsed = window && window.sessionStorage.getItem('sidebarCollapsed') !== 'false'

const mainStore = {
  state: {
    breadcrumbs: [],
    sidebarCollapsed: inIframe(), // sidebarCollapsed,
    dirty: [],
    clientWidth: null
  },
  mutations: {
    SET_BREADCRUMBS (state, breadcrumbs) { state.breadcrumbs = breadcrumbs },
    SET_SIDEBAR_COLLAPSED (state, collapsed) {
      state.sidebarCollapsed = collapsed
      sessionStorage.setItem('sidebarCollapsed', collapsed)
    },
    SET_DIRTY (state, { key, value }) {
      let index = state.dirty.indexOf(key)

      if (value) {
        if (index === -1) {
          state.dirty.push(key)
        }
      } else {
        if (index > -1) {
          state.dirty.splice(index, 1)
        }
      }
    },
    SHOW_ALERT (state, alert) {
      // Do nothing, this is for AlertsHandler to listen to
    },
    SET_CLIENT_DIMENSIONS (state, { height, width }) {
      state.clientWidth = width
    }
  }
}

const debug = process.env.NODE_ENV !== 'production'

function inIframe () { // stackoverflow
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const store = new Vuex.Store({
  modules: {
    main: mainStore,
    login: loginStore,
    menu: menuStore,
    locations,
    menuPublish,
    dialogs,
    navigation
  },
  strict: debug
})

export default store
